module.exports = __webpack_public_path__ + "public/img/yl.129d6929.png";